'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452 from "./presto.types$-Credential-Username$$anon$52.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453 from "./presto.types$-Credential-Username$$anon$53.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsername$() {
  this.c4T = null;
  this.c4U = false;
  this.c4X = null;
  this.c4Y = false;
  this.c4V = null;
  this.c4W = false;
  this.c4Z = null;
  this.c50 = false;
}
export { $c_Lpresto_types$CredentialUsername$ as $c_Lpresto_types$CredentialUsername$ };
$p = $c_Lpresto_types$CredentialUsername$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsername$;
/** @constructor */
function $h_Lpresto_types$CredentialUsername$() {
}
export { $h_Lpresto_types$CredentialUsername$ as $h_Lpresto_types$CredentialUsername$ };
$h_Lpresto_types$CredentialUsername$.prototype = $p;
$p.gI = (function() {
  if ((!this.c4U)) {
    this.c4T = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c4U = true;
  }
  return this.c4T;
});
$p.csf = (function() {
  if ((!this.c4Y)) {
    this.c4X = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4Y = true;
  }
  return this.c4X;
});
$p.cIr = (function() {
  if ((!this.c4W)) {
    this.c4V = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452.$c_Lpresto_types$CredentialUsername$$anon$52(this);
    this.c4W = true;
  }
  return this.c4V;
});
$p.a2K = (function() {
  if ((!this.c50)) {
    this.c4Z = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453.$c_Lpresto_types$CredentialUsername$$anon$53(this);
    this.c50 = true;
  }
  return this.c4Z;
});
var $d_Lpresto_types$CredentialUsername$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsername$, "presto.types$CredentialUsername$", ({
  Z4: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialUsername$ as $d_Lpresto_types$CredentialUsername$ };
var $n_Lpresto_types$CredentialUsername$;
function $m_Lpresto_types$CredentialUsername$() {
  if ((!$n_Lpresto_types$CredentialUsername$)) {
    $n_Lpresto_types$CredentialUsername$ = new $c_Lpresto_types$CredentialUsername$();
  }
  return $n_Lpresto_types$CredentialUsername$;
}
export { $m_Lpresto_types$CredentialUsername$ as $m_Lpresto_types$CredentialUsername$ };
//# sourceMappingURL=presto.types$-Credential-Username$.js.map
